import {useCallback, useEffect} from 'react';
import {RouteComponentProps} from 'react-router';
import {useHistory} from 'react-router-dom';

import {clientActionsApi} from 'api';
import {Loader} from 'components';
import {ROUTE_PATH} from 'constants/routes';
import {ClientContext} from 'context';
import {useApiData} from 'hooks';
import {InviteeParticipantRole, ParticipantRole} from 'types';
import {transformUtils} from 'utils/transform';

import {ClientContextProps} from '../types';
import {WithClientSessionParams, withClientSessionParamsFromUrl} from '../withClientSessionParamsFromUrl';

import {ClientJoinSession} from './ClientJoinSession';
import './styles.scss';

type MatchParams = {
    code: string;
    pin: string;
}

type Props = RouteComponentProps<MatchParams> & WithClientSessionParams & {
    role?: InviteeParticipantRole;
};

export const ClientJoinSessionPage = withClientSessionParamsFromUrl()<Props>(({match, role, clientSessionParams}: Props) => {
    const history = useHistory();
    const {
        data: clientSessionSettings,
        send: getClientSettings,
        loading: settingsLoading
    } = useApiData(clientActionsApi.getJoinSessionSettings, {loadingDefault: !!clientSessionParams.assignmentInfo});

    useEffect(() => {
        if (clientSessionParams.assignmentInfo) {
            getClientSettings(clientSessionParams.assignmentInfo);
        }
    }, [clientSessionParams, getClientSettings]);

    const onSubmit = useCallback((values) => {
        const link = (role as any as ParticipantRole) === ParticipantRole.Guest ?
            ROUTE_PATH.GUEST.JOIN_WITH_CODE : ROUTE_PATH.CLIENT.JOIN_WITH_CODE;
        history.push(
            transformUtils.substituteLink(link, values)
        );
    }, [history, role]);

    if (settingsLoading) {
        return <Loader svgClassName='tw-max-w-12 tw-max-h-12' />;
    }

    return (
        <ClientContext.Provider value={{settings: clientSessionSettings} as ClientContextProps}>
            <ClientJoinSession match={match.params} role={role} onSubmit={onSubmit} />
        </ClientContext.Provider>
    );
});
